/**
 * wildflour-product.js — the product page's only script.
 *
 * Progressive enhancement over a plain product form. Without it the radios
 * still render and a <noscript> select posts the chosen variant, so the page
 * can always add to bag. With it:
 *
 *   - picking an option finds the matching variant, updates the hidden id,
 *     the price, the button and the URL, and swaps the picture when the
 *     variant has one;
 *   - values that don't exist for the current combination are disabled,
 *     values that exist but are sold out are marked;
 *   - the quantity stepper's +/- work;
 *   - thumbnails swap the main picture;
 *   - the form posts to /cart/add with fetch and then goes to the bag.
 */

(function () {
  'use strict';

  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var dataEl = root.querySelector('[data-pdp-variants]');
  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var moneyFormat = root.getAttribute('data-money-format') || '€{{amount}}';
  var packIndex = parseInt(root.getAttribute('data-pack-index'), 10);
  if (isNaN(packIndex)) packIndex = -1;

  var form = root.querySelector('[data-pdp-form]');
  var idInput = root.querySelector('[data-pdp-id]');
  var qtyInput = root.querySelector('input[name="quantity"]');
  var priceEl = root.querySelector('[data-pdp-price]');
  var summaryEl = root.querySelector('[data-pdp-summary]');
  var addBtn = root.querySelector('[data-pdp-add]');
  var addLabel = root.querySelector('[data-pdp-add-label]');
  var addPriceWrap = root.querySelector('[data-pdp-add-price-wrap]');
  var addPrice = root.querySelector('[data-pdp-add-price]');
  var errorEl = root.querySelector('[data-pdp-error]');
  var mainImg = root.querySelector('[data-pdp-main]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-pdp-thumb]'));
  var optionInputs = Array.prototype.slice.call(root.querySelectorAll('[data-option-index]'));

  var addText = addLabel ? addLabel.textContent : 'Add to bag';
  var soldOutText = 'Sold out';
  var optionCount = variants.length && variants[0].options ? variants[0].options.length : 0;

  /* ------------------------------------------------------------ money */

  function formatMoney(cents) {
    var value = (parseInt(cents, 10) || 0) / 100;
    var match = moneyFormat.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var out;

    function withSeparators(num, decimals, thousands, decimal) {
      var fixed = num.toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }

    switch (key) {
      case 'amount_no_decimals':
        out = withSeparators(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        out = withSeparators(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        out = withSeparators(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        out = withSeparators(value, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        out = withSeparators(value, 0, ' ', '.');
        break;
      case 'amount_with_space_separator':
        out = withSeparators(value, 2, ' ', ',');
        break;
      default:
        out = withSeparators(value, 2, ',', '.');
    }

    return moneyFormat.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* --------------------------------------------------------- variants */

  function selectedOptions() {
    var selected = [];
    for (var i = 0; i < optionCount; i++) {
      var checked = optionInputs.filter(function (input) {
        return parseInt(input.getAttribute('data-option-index'), 10) === i && input.checked;
      })[0];
      selected[i] = checked ? checked.value : null;
    }
    return selected;
  }

  function findVariant(selected) {
    for (var v = 0; v < variants.length; v++) {
      var ok = true;
      for (var i = 0; i < selected.length; i++) {
        if (variants[v].options[i] !== selected[i]) { ok = false; break; }
      }
      if (ok) return variants[v];
    }
    return null;
  }

  function quantity() {
    var q = qtyInput ? parseInt(qtyInput.value, 10) : 1;
    return q > 0 ? q : 1;
  }

  function packCount(variant) {
    if (packIndex < 0 || !variant) return 0;
    var n = parseInt(variant.options[packIndex], 10);
    return n > 0 ? n : 0;
  }

  function markAvailability(selected) {
    optionInputs.forEach(function (input) {
      var index = parseInt(input.getAttribute('data-option-index'), 10);
      var trial = selected.slice();
      trial[index] = input.value;

      var exists = false;
      var available = false;
      for (var v = 0; v < variants.length; v++) {
        var ok = true;
        for (var i = 0; i < trial.length; i++) {
          if (trial[i] !== null && variants[v].options[i] !== trial[i]) { ok = false; break; }
        }
        if (ok) {
          exists = true;
          if (variants[v].available) { available = true; break; }
        }
      }

      var wrap = input.parentNode;
      input.disabled = !exists;
      wrap.classList.toggle('tile--soldout', exists && !available && wrap.classList.contains('tile'));
      wrap.classList.toggle('pill--soldout', exists && !available && wrap.classList.contains('pill'));
    });
  }

  function showMedia(mediaId) {
    if (!mainImg || !mediaId) return;
    var thumb = thumbs.filter(function (t) {
      return t.getAttribute('data-media-id') === String(mediaId);
    })[0];
    if (thumb) activateThumb(thumb);
  }

  function update() {
    var selected = selectedOptions();
    var variant = optionCount ? findVariant(selected) : variants[0];

    markAvailability(selected);

    // Colour label: "Colour: Natural".
    selected.forEach(function (value, index) {
      var label = root.querySelector('[data-option-label="' + index + '"]');
      if (label && value !== null) label.textContent = value;
    });

    if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

    if (!variant) {
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Unavailable';
      if (addPriceWrap) addPriceWrap.hidden = true;
      return;
    }

    if (idInput) idInput.value = variant.id;

    var bags = packCount(variant);
    if (priceEl) {
      priceEl.textContent = formatMoney(bags ? Math.round(variant.price / bags) : variant.price);
    }

    if (summaryEl && packIndex > -1) {
      summaryEl.textContent = variant.options[packIndex] + ' · ' + formatMoney(variant.price);
    }

    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? addText : soldOutText;
      if (addPriceWrap) addPriceWrap.hidden = !variant.available;
      if (addPrice) addPrice.textContent = formatMoney(variant.price * quantity());
    }

    if (variant.featured_media && variant.featured_media.id) {
      showMedia(variant.featured_media.id);
    }

    if (window.history && window.history.replaceState && optionCount) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  optionInputs.forEach(function (input) {
    input.addEventListener('change', update);
  });

  /* --------------------------------------------------------- quantity */

  var qtyWrap = root.querySelector('[data-pdp-qty]');
  if (qtyWrap && qtyInput) {
    var minus = qtyWrap.querySelector('[data-qty-minus]');
    var plus = qtyWrap.querySelector('[data-qty-plus]');

    function setQty(n) {
      qtyInput.value = n > 0 ? n : 1;
      update();
    }

    if (minus) minus.addEventListener('click', function () { setQty(quantity() - 1); });
    if (plus) plus.addEventListener('click', function () { setQty(quantity() + 1); });
    qtyInput.addEventListener('change', function () { setQty(quantity()); });
  }

  /* ---------------------------------------------------------- gallery */

  function activateThumb(thumb) {
    if (!mainImg) return;
    mainImg.src = thumb.getAttribute('data-src');
    mainImg.srcset = thumb.getAttribute('data-srcset') || '';
    mainImg.alt = thumb.getAttribute('data-alt') || '';
    thumbs.forEach(function (t) {
      t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () { activateThumb(thumb); });
  });

  /* ------------------------------------------------------- add to bag */

  if (form && window.fetch && window.FormData) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (addBtn && addBtn.disabled) return;

      var body = new FormData(form);
      var previous = addLabel ? addLabel.textContent : '';
      if (addBtn) addBtn.disabled = true;
      if (addLabel) addLabel.textContent = 'Adding…';

      fetch(form.getAttribute('action') || '/cart/add', {
        method: 'POST',
        body: body,
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) throw new Error(json.description || json.message || 'Could not add to bag.');
            window.location.href = root.getAttribute('data-cart-url') || '/cart';
          });
        })
        .catch(function (error) {
          if (addBtn) addBtn.disabled = false;
          if (addLabel) addLabel.textContent = previous;
          if (errorEl) {
            errorEl.textContent = error.message || 'Could not add to bag.';
            errorEl.hidden = false;
          }
        });
    });
  }

  update();
})();
